import { ReactNode } from 'react';

import { Info } from 'lucide-react';

import { SimpleTooltip } from '@/components/ui/simple-tooltip';
import { cn } from '@/lib/utils';

interface StatCardProps {
  icon: ReactNode;
  title: ReactNode;
  infoTooltip?: ReactNode;
  /** Optional control rendered at the right of the header (e.g. an edit button). */
  headerAction?: ReactNode;
  children: ReactNode;
  className?: string;
}

export const StatCard = ({
  icon,
  title,
  infoTooltip,
  headerAction,
  children,
  className,
}: StatCardProps) => {
  return (
    <div
      className={cn(
        'flex h-full flex-col gap-4 rounded-lg bg-muted p-4 text-foreground',
        className
      )}
    >
      <div className="flex items-center gap-2">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-foreground text-background">
          {icon}
        </div>
        <span className="flex-1 truncate text-base font-semibold">{title}</span>
        {infoTooltip && (
          <SimpleTooltip content={infoTooltip}>
            <button
              type="button"
              className="text-muted-foreground transition-colors hover:text-foreground"
              aria-label="More info"
            >
              <Info className="h-4 w-4" />
            </button>
          </SimpleTooltip>
        )}
        {headerAction}
      </div>
      <div className="flex flex-1 flex-col gap-2">{children}</div>
    </div>
  );
};
